import {createWidget, CreateWidget} from "./create/CreateWidgetComponent";
import {chartWidget, ChartWidget} from "./chart/ChartWidgetComponent";
import {watchlistWidget, WatchlistWidget} from "./watchlist/WatchlistWidgetComponent";
import {newsWidget, NewsWidget} from "./news/NewsWidgetComponent";
import {orderDepthWidget, OrderDepthWidget} from "./depth/OrderDepthWidgetComponent";
import {tradeIdeasWidget, TradeIdeasWidget} from "./trade-ideas/TradeIdeasWidgetComponent";
import {courseOfSalesWidget, CourseOfSalesWidget} from "./course-of-sales/CourseOfSalesWidgetComponent";

import MarketMap from "./market-map";
import TimeSeries from "./timeseries";
import {quoteWidget, QuoteWidget} from "./quote/QuoteWidgetComponent";
import {marketMoversWidget, MarketMoversWidget} from "./market-movers/MarketMoversWidgetComponent";
import {openTraderHelpWidget, OpenTraderHelpWidget} from "./open-trader-help/OpenTraderHelpWidgetComponent";

export default function() {
    const name = "tfApp.dashboard.oms.components.widgets";
    return angular.module(name, [MarketMap(), TimeSeries(name)])
                  .component(ChartWidget, chartWidget())
                  .component(CreateWidget, createWidget())
                  .component(CourseOfSalesWidget, courseOfSalesWidget())
                  .component(MarketMoversWidget, marketMoversWidget())
                  .component(NewsWidget, newsWidget())
                  .component(OrderDepthWidget, orderDepthWidget())
                  .component(QuoteWidget, quoteWidget())
                  .component(TradeIdeasWidget, tradeIdeasWidget())
                  .component(WatchlistWidget, watchlistWidget())
                  .component(OpenTraderHelpWidget, openTraderHelpWidget())
                  .name;
}
